var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotSparklesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52599 5.89746C9.93949 3.78041 10.2758 3.40836 12.1846 2.94877C10.2758 2.48917 9.94094 2.11712 9.52599 7.65384e-05C9.1125 2.11712 8.77618 2.48917 6.86742 2.94877C8.77618 3.40836 9.11105 3.78041 9.52599 5.89746Z",
    fill: "#D2042D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98822 4.71411C5.05495 9.48367 4.29931 10.3226 -0.000131026 11.3571C4.29931 12.3915 5.05495 13.2304 5.98821 18C6.92148 13.2304 7.67712 12.3915 11.9766 11.3571C7.67712 10.3226 6.92148 9.48367 5.98822 4.71411Z",
    fill: "#D2042D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9891 5.57059C14.5203 7.96923 14.1403 8.39089 11.9782 8.91176C14.1403 9.43263 14.5203 9.85429 14.9891 12.2529C15.4579 9.85429 15.8379 9.43263 18 8.91176C15.8379 8.39089 15.4579 7.96923 14.9891 5.57059Z",
    fill: "#D2042D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotSparklesIcon);
export default __webpack_public_path__ + "static/media/chatbot-sparklesIcon.3300f6d95db1789d9f7f9f9435d1d3b1.svg";
export { ForwardRef as ReactComponent };